export function normalizeFullName(value) {
  if (value == null) return '';
  return String(value).trim().replace(/\s+/g, ' ');
}

export function getFirstNameToken(fullName) {
  const normalized = normalizeFullName(fullName);
  if (!normalized) return '';
  return normalized.split(' ')[0] || '';
}

export function getInitialsFromFullName(fullName) {
  const parts = normalizeFullName(fullName).split(' ').filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
}
